// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubmittedContent-module--wrapper--VVmaN","successMessage":"SubmittedContent-module--successMessage--3o_3X"};